module.exports = __webpack_public_path__ + "media/images/shark/Heffalump-p-500-39b434281d706135fed55a0efbb304aa.jpeg";